import Vue from 'vue'
import App from './App.vue'
import store from './store'
import { router } from './plugins/vue-router'
import './plugins/vuex'
import './plugins/vant'
import './utils/axios'
import './utils/lodash'
import '@/assets/css/common.styl'
import './plugins/signature-h5'

Vue.config.productionTip = false

// import VConsole from 'vconsole'
// console.log(process.env.NODE_ENV, 'process.env.VUE_APP_RUN_ENV')
// if (process.env.NODE_ENV != 'production') {
// const vConsole = new VConsole()
// Vue.use(vConsole)
// console.info('vconsole-info-测试')
// }

new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
